import React from 'react';
import './style.scss';
import { NavLink } from 'react-router-dom';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { IconName, findIcon } from 'utils/handleIcon';
import { PositionListItemFragment } from 'views/utils/graphql/graphql';
import { ListItem } from 'views/mutual/list';
import { PagePathFactory } from 'constants/pagePath';
import { formatPrice, formatRate } from 'views/utils/converter';
import { IssuanceDocumentType } from 'constants/IssuanceDocument';
import { ProductType, ProductTypeMap } from 'constants/productType';
import { PositionStatus, PositionStatusMap } from 'constants/position';

type PositionListItemProps = {
  itemIndex: number;
  position: PositionListItemFragment;
};

const fileIcon = findIcon(IconName.file);

const PositionListItem: React.FC<PositionListItemProps> = ({ itemIndex, position }: PositionListItemProps) => {
  return (
    <ListItem itemIndex={itemIndex} className="positionListItem">
      <div className="positionListItem_title">
        <div className="positionListItem_label">案件名</div>
        <div className="positionListItem_value">{position.SymbolShortName}</div>
      </div>
      <div className="positionListItem_tenant">
        <div className="positionListItem_label">
          賃借人等<span className="positionList_small_text">※1</span>
        </div>
        <div className="positionListItem_value">{position.TenantName}</div>
      </div>
      <div className="positionListItem_division">
        <div className="positionListItem_label">損益分配日</div>
        <div className="positionListItem_value">
          {position.PaLDistMonth.map((x, index) => (
            <>
              {x}末日{index + 1 < position.PaLDistMonth.length && <br />}
            </>
          ))}
        </div>
      </div>
      <div className="positionListItem_rate">
        <div className="positionListItem_label">
          事業開始時為替レート<span className="positionList_small_text">※2</span>
        </div>
        <div className="positionListItem_value">{formatRate(position.InitialExchangeRate)}</div>
      </div>
      <div className="positionListItem_investmentUSD">
        <div className="positionListItem_label">出資金額($)</div>
        <div className="positionListItem_value">{formatPrice(position.InvestmentAmountDollar)}</div>
      </div>
      <div className="positionListItem_investmentJPY">
        <div className="positionListItem_label">出資金額(¥)</div>
        <div className="positionListItem_value">{formatPrice(position.InvestmentAmountYen)}</div>
      </div>
      <div className="positionListItem_contractDate">
        <div className="positionListItem_label">契約締結日</div>
        <div className="positionListItem_value">{position.ContractDate}</div>
      </div>
      <div className="positionListItem_purchaseOption">
        <div className="positionListItem_label">購入選択権設定日</div>
        <div className="positionListItem_value">{oneStringToMultiElement(position.PurchaseOptionDate)}</div>
      </div>
      <div className="positionListItem_leaseEndDate">
        <div className="positionListItem_label">リース満了日</div>
        <div className="positionListItem_value">{position.LeaseEndDate}</div>
      </div>
      <div className="positionListItem_status">
        <div className="positionListItem_label">ステータス</div>
        <div className="positionListItem_value">{PositionStatusMap[position.Status as PositionStatus]?.name}</div>
      </div>
      <div className="positionListItem_contract">
        <div className="positionListItem_label">契約関連書類</div>
        <div className="positionListItem_value">
          {position.HasIssuanceDoc ? (
            <NavLink
              data-label="契約関連書類"
              to={PagePathFactory.issuanceDocumentContract(
                ProductTypeMap[position.ProductType as ProductType]?.documentType,
                position.Symbol,
              )}
            >
              <SvgIcon icon={fileIcon} size={IconSize.icon_s} />
            </NavLink>
          ) : (
            <div className="disabled">
              <SvgIcon icon={fileIcon} size={IconSize.icon_s} />
            </div>
          )}
        </div>
      </div>
    </ListItem>
  );
};

const oneStringToMultiElement = (target: String) => {
  return (
    <>
      {target.split(',').map((x) => (
        <span>{x.trim()}</span>
      ))}
    </>
  );
};

export type PositionListProps = {
  items: Array<PositionListItemFragment | null>;
  isLoading: boolean;
};
export const PositionList = ({ items }: PositionListProps) => {
  return (
    <>
      {items
        ?.filter((x) => (x ? true : false))
        .map((item, index) => (
          <PositionListItem key={index} itemIndex={index} position={item!} />
        ))}
    </>
  );
};
